import { useQueryClient } from "@tanstack/react-query";

import {
  getGetUserProgramQueryKey,
  useUpdateUserProgramCareTeam as useGeneratedUpdateUserProgramCareTeam,
} from "@/api/generated";

export const useUpdateUserProgramCareTeam = () => {
  const queryClient = useQueryClient();
  return useGeneratedUpdateUserProgramCareTeam({
    mutation: {
      onSuccess: (_response, { program }) =>
        queryClient.invalidateQueries({
          queryKey: getGetUserProgramQueryKey(program),
        }),
    },
  });
};
